import { render, staticRenderFns } from "./RemoveBranding.vue?vue&type=template&id=1a1f86ee"
import script from "./RemoveBranding.vue?vue&type=script&lang=js"
export * from "./RemoveBranding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports